import * as axios from "axios";
import { getAuthHeader, getUploadFileHeader } from "../utils";

export const applyEtour = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}etour/add`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getEtourList = (year: number) => {
  const url = `${process.env.REACT_APP_BASE_URL}etour/list?y=${year}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getEtourDetail = (code: string) => {
  const url = `${process.env.REACT_APP_BASE_URL}etour/detail?code=${code}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const addComment = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}etour/comment`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getCommentList = (code: string) => {
  const url = `${process.env.REACT_APP_BASE_URL}etour/comment?c=${code}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const addReimbursement = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}reimbursement/add`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getReimbursementDetail = (code: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}reimbursement/detail?c=${code}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const modeOfTravel = () => {
  const url = `${process.env.REACT_APP_BASE_URL}mode/of/travel`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};
export const uploadBill = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}reimbursement/attachment`;
  const formData = new FormData();
  formData.append("eTourCode", model.eTourCode);
  formData.append("transactionUID", model.transactionUID);
  formData.append("reimbursementType", model.reimbursementType);
  formData.append("attachment", model.attachment);

  return axios
    .post(url, formData, getUploadFileHeader())
    .then((response: any) => {
      return response.data;
    });
};

export const uploadAttachment = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}etour/attachment`;
  const formData = new FormData();
  formData.append("eTourCode", model.eTourCode);
  formData.append("commentCode", model.commentCode);
  formData.append("attachment", model.attachment);

  return axios
    .post(url, formData, getUploadFileHeader())
    .then((response: any) => {
      return response.data;
    });
};

export const uploadDetailAttachment = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}etour/detail-attachment`;
  const formData = new FormData();
  formData.append("eTourCode", model.eTourCode);
  formData.append("commentCode", model.commentCode);
  formData.append("attachment", model.attachment);

  return axios
    .post(url, formData, getUploadFileHeader())
    .then((response: any) => {
      return response.data;
    });
};
